<template>
    <div>
        <VersaoRelatorioDialog :dialog="dialogVersaoRelatorio" :relm_id="model.relm_id"
            @versaoRelatorioDialogClose="versaoRelatorioDialogClose" />

        <v-dialog v-model="isDialog" :max-width="800">
            <v-card>
                <v-card-title class="bg-header grey lighten-4">
                    <span class="text-h6 font-weight-bold grey--text text--darken-3">
                        <v-icon left color="primary">mdi-file-document-edit-outline</v-icon>
                        Modelo de Relatório
                    </span>
                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialogCloseModelosRelatorioDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pt-4 px-4 pb-3">
                    <div>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field outlined dense v-model="model.relm_descricao" label="Nome do Modelo"
                                    hide-details type="text"
                                    @input="model.relm_descricao = ($event || '').toUpperCase()" />
                            </v-col>
                        </v-row>

                        <v-row dense v-if="!isNovo">
                            <!-- Coluna 1: PDF -->
                            <v-col cols="12" md="6">
                                <span v-if="model.relm_url_pdf"
                                    class="caption success--text font-weight-bold d-flex align-center mt-1">
                                    <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                                    PDF já foi anexado e salvo
                                </span>

                                <span v-else class="caption grey--text text--darken-1 d-flex align-center mt-1">
                                    <v-icon small color="grey" class="mr-1">mdi-alert-circle-outline</v-icon>
                                    Nenhum PDF anexado ainda.
                                </span>

                                <div class="d-flex align-center">
                                    <v-file-input v-model="pdfFile" label="Upload do Arquivo PDF" accept=".pdf" outlined
                                        dense prepend-icon="" prepend-inner-icon="mdi-cloud-upload-outline" hide-details
                                        class="mr-1 w-100" />

                                    <v-btn :disabled="!model.relm_url_pdf || pdfFile" color="primary" class="px-2"
                                        min-width="40" :href="model.relm_url_pdf" target="_blank">
                                        <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>

                            <!-- Coluna 2: Relatório .RPT -->
                            <v-col cols="12" md="6">
                                <span v-if="model.relm_url_report"
                                    class="caption success--text font-weight-bold d-flex align-center mt-1">
                                    <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                                    Relatório já foi anexado e salvo
                                </span>

                                <span v-else class="caption grey--text text--darken-1 d-flex align-center mt-1">
                                    <v-icon small color="grey" class="mr-1">mdi-alert-circle-outline</v-icon>
                                    Nenhum Relatório anexado ainda.
                                </span>

                                <v-file-input v-model="report" label="Upload Relatório" accept=".rpt" outlined dense
                                    prepend-icon="" prepend-inner-icon="mdi-upload-network" hide-details
                                    class="w-100" />
                            </v-col>
                        </v-row>

                        <v-row dense class="d-flex justify-space-between align-center">
                            <v-col cols="auto" v-if="!isNovo">
                                <v-checkbox label="Versionar" v-model="model.relm_versionar"></v-checkbox>
                            </v-col>

                            <v-col cols="auto" class="ml-auto">
                                <v-btn color="success" class="text-none" @click="saveClick">
                                    <v-icon left>mdi-content-save-check</v-icon>
                                    Salvar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <v-divider class="my-1"></v-divider>

                    <v-row v-if="isNovo == false && model.relm_versionar">
                        <v-col>
                            <v-row dense>
                                <v-col cols="12" class="d-flex justify-end">
                                    <v-btn color="primary" class="text-none" @click="novoVersaoClick">
                                        Nova Versão
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row dense>
                                <v-col cols="12">
                                    <v-data-table :headers="headers" :items="relversoes" class="elevation-1"
                                        :loading="loading" dense no-data-text="Nenhum modelo encontrado">

                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-btn class="text-none" size="small" text color="error" icon
                                                @click="excluiRelversoesClick(item)">
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </template>

                                        <template v-slot:[`item.relv_url`]="{ item }">
                                            <v-btn text :href="item.relv_url" icon color="primary">
                                                <v-icon>mdi-download</v-icon>
                                            </v-btn>
                                        </template>

                                        <template v-slot:[`item.relpadrao`]="{ item }">
                                            <v-icon :color="item.relpadrao ? 'success' : 'grey lighten-1'" small>
                                                {{ item.relpadrao ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
                                            </v-icon>
                                        </template>

                                        <template v-slot:[`item.created_at`]="{ item }">
                                            <span>
                                                {{ item.created_at ? new Date(item.created_at).toLocaleString('pt-BR') :
                                                    '-' }}
                                            </span>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <div class="mt-5">ID: {{ model.relm_id }}</div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { RelmodelosService } from '../../services/reports/relmodelosService.js';
import { RelversoesService } from '../../services/reports/relversoesService.js';
import VersaoRelatorioDialog from './VersaoRelatorioDialog.vue'

const relmodelosService = new RelmodelosService();
const relversoesService = new RelversoesService();

export default {
    props: {
        rela_id: String,
        relm_id: String,
        dialog: Boolean,
    },
    components: {
        VersaoRelatorioDialog
    },
    data: () => ({
        loading: false,
        isNovo: false,
        pdfFile: null,
        report: null,
        dialogVersaoRelatorio: false,
        model: {
            relm_id: '',
            rela_id: '',
            relm_descricao: '',
            relm_url_pdf: '',
            relm_url_report: '',
            relm_versionar: false,
        },
        headers: [
            { text: '>= v(SIC)', value: 'relv_vsic', align: 'start' },
            { text: 'Padrão', value: 'relpadrao', align: 'start' },
            { text: 'Criado Em:', value: 'created_at', align: 'start' },
            { text: 'URL', value: 'relv_url', align: 'start' },
            { text: 'Ação', value: 'actions', align: 'center' },
        ],
        relversoes: [],
    }),
    methods: {
        versaoRelatorioDialogClose() {
            this.dialogVersaoRelatorio = false;
            this.carregarRelversoes();
        },
        async novoVersaoClick() {
            this.dialogVersaoRelatorio = true;
        },
        async excluiRelversoesClick(redetalhe) {
            const confirmou = await this.$root.$confirm(
                'Exclusão',
                'Deseja realmente excluir?',
            );
            if (!confirmou) return;

            await relversoesService.remove(redetalhe.relm_id, redetalhe.relv_id);
            this.carregarRelversoes();

            this.$store.dispatch('showSuccess', 'Excluído com sucesso!')
        },
        async saveClick() {
            if (this.validaSalvar() == false) return;

            try {
                this.$isLoading(true);

                this.model.rela_id = this.rela_id;
                // eslint-disable-next-line no-console
                console.log(this.model);

                let form = new FormData()
                form.append('relm_descricao', this.model.relm_descricao)
                form.append('relm_versionar', this.model.relm_versionar)
                form.append('rela_id', this.rela_id)

                if (this.pdfFile)
                    form.append('pdf', this.pdfFile)

                if (this.report)
                    form.append('report', this.report)

                if (this.model.relm_id) {
                    form.append('relm_id', this.model.relm_id)
                    this.model = await relmodelosService.update(this.rela_id, this.model.relm_id, form);
                }
                else {
                    this.model = await relmodelosService.create(this.rela_id, form);
                }

                this.pdfFile = null;
                this.report = null;
                this.isNovo = false;
                this.carregarRelversoes();

                this.$store.dispatch('showSuccess', 'Salvo com sucesso!')
                // this.dialogClose();
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.$isLoading(false);
            }
        },
        validaSalvar() {
            if (!this.model.relm_descricao) {
                this.$store.dispatch('showError', "Informe o Nome do Modelo")
                return false;
            }
            return true
        },
        dialogCloseModelosRelatorioDialog() {
            this.$emit('dialogCloseModelosRelatorioDialog')
        },
        async carregarRelversoes() {
            this.loading = true;
            try {
                this.relversoes = await relversoesService.getAll(this.model.relm_id);
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        isDialog: {
            get() {
                return this.dialog
            },
            set() {
                this.dialogCloseModelosRelatorioDialog();
            }
        }
    },
    watch: {
        async dialog() {
            this.model = {
                relm_versionar: false
            };
            
            this.relversoes = [];
            this.isNovo = true;
            this.pdfFile = null;
            this.report = null;

            if (this.relm_id) {
                this.isNovo = false;
                this.model = await relmodelosService.get(this.rela_id, this.relm_id);
                // eslint-disable-next-line no-console
                //console.log(this.model);
                this.carregarRelversoes();
            }
        }
    }
}
</script>
